import { useEffect, useState } from 'react'
import posthog from 'posthog-js'

import {
    addToHomeScreen,
    rememberDismissed,
    shouldOfferHomeScreen,
} from 'modules/miniapp'

/**
 * "Add Hamyan to your home screen", shown once, right after a login inside a
 * messenger mini app.
 *
 * `shouldOfferHomeScreen()` does the gating: it only returns true when the
 * client reports we are installable *and* not already installed, when the user
 * has not previously declined, and when a session was established on this very
 * launch. So this renders nothing on the web, nothing on desktop clients,
 * nothing for people who already added us, and nothing on a casual re-open.
 */
export default function AddToHomeScreenPrompt() {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        let cancelled = false
        shouldOfferHomeScreen().then((should) => {
            if (cancelled || !should) return
            setVisible(true)
            posthog.capture('miniapp_home_screen_offered')
        })
        return () => {
            cancelled = true
        }
    }, [])

    if (!visible) return null

    const dismiss = () => {
        // Remembered across launches — "no" should mean no, not "ask me again
        // tomorrow".
        rememberDismissed()
        setVisible(false)
        posthog.capture('miniapp_home_screen_dismissed')
    }

    const accept = () => {
        posthog.capture('miniapp_home_screen_accepted')
        addToHomeScreen()
        // The client owns the rest of the flow; treat the ask as spent either
        // way so we never show it twice.
        rememberDismissed()
        setVisible(false)
    }

    return (
        <div className="mx-4 mt-3 bg-white rounded-lg shadow-header p-4 flex flex-col gap-3">
            <div>
                <p className="text-sm font-bold">همیان روی صفحهٔ اصلی</p>
                <p className="text-xs text-text-gray mt-1 leading-6">
                    برای دسترسی سریع‌تر، همیان را به صفحهٔ اصلی گوشی خود اضافه
                    کنید.
                </p>
            </div>
            <div className="flex gap-2">
                <button
                    type="button"
                    onClick={accept}
                    className="bg-green-1 text-white text-sm rounded-md py-2 px-4 grow"
                >
                    افزودن
                </button>
                <button
                    type="button"
                    onClick={dismiss}
                    className="text-text-gray text-sm rounded-md py-2 px-4 border border-gray-1"
                >
                    بعداً
                </button>
            </div>
        </div>
    )
}
